import React from 'react';
import type {FC} from 'react';
import {Link} from '@gravity-ui/uikit';

import {TransformedResponseError} from '~shared/models';

import {IS_INTERNAL} from '~ui/constants';

import {cnContainsSecretMessage} from './ContainsSecretMessage.classname';

import {YAV_LINK} from './constants';
import {i18n} from './i18n';

import './ContainsSecretMessage.scss';

export interface ContainsSecretMessageProps {
    error: TransformedResponseError<string[]>;
}

export const ContainsSecretMessage: FC<ContainsSecretMessageProps> = ({error}) => {
    if (!IS_INTERNAL) {
        return null;
    }

    const details = error.details.data;

    return (
        <div className={cnContainsSecretMessage()}>
            {i18n('title')}
            {':'}
            <ul className={cnContainsSecretMessage('Ul')}>
                {details.map((token, i) => (
                    <li key={i}>
                        <div className={cnContainsSecretMessage('Token')} title={token}>
                            {token}
                        </div>
                    </li>
                ))}
            </ul>
            {i18n('label-yav')}{' '}
            <Link href={YAV_LINK} target="_blank" view="normal-visitable">
                {i18n('link-yav')}
            </Link>
        </div>
    );
};
